<template lang="pug">
  .aside__block
    Head
    Form

</template>

<script>
import Head from './Head';
import Form from './Form';

import { mapActions } from 'vuex';

export default {
  components: { Head, Form },
  destroyed() {
    this.setAsideData({ path: 'lesson', value: {} });
    this.setAsideData({ path: 'course', value: {} });
    this.setAsideData({ path: 'idx', value: '' });
    this.setAsideMeta({ path: 'copy', value: false });
    this.setAsideMeta({ path: 'canSave', value: false });
  },
  methods: {
    ...mapActions('coursesFolder', ['setAsideMeta', 'setAsideData'])
  }
};
</script>
